<!-- 1. Compliance Posture Summary for Baselines -->
<div class="A4" *ngIf="all_loaded$ | async">
  <lib-header class="flex-row" [data]="header$ | async"></lib-header>

  <div class="section-wrapper">
    <div class="section">
      <h1>Compliance Posture Summary</h1>
      <lib-top-threats
        [all_posture_count]="allBaselinesPostureCount$ | async"
        [tenant_posture_controls_in_this_period]="tenant_baselines_posture_controls_in_this_period$ | async"
        [group_posture_controls_in_this_period]="group_baselines_posture_controls_in_this_period$ | async"
      ></lib-top-threats>
    </div>
  </div>

  <!-- 2. If it has PSA, then show Security Investigations with Ticket Status Changes -->
  <div class="section-wrapper" *ngIf="hasPSA; else top_5_user_under_threats">
    <div class="section">
      <h1>Security Investigations</h1>
      <lib-top-threats [alerts]="alerts$ | async"> </lib-top-threats>
      <lib-top-threats [psaTicketCount]="ticketCount$ | async"></lib-top-threats>
    </div>
  </div>

  <!-- 2. If it doesn't have PSA, show Top 5 Users under Threats with Alerts  -->
  <ng-template #top_5_user_under_threats>
    <div class="section-wrapper">
      <div class="section">
        <h1>Top 5 Users under Threats</h1>
        <lib-top-threats [alertsByUsers]="alertsByUsers$ | async"> </lib-top-threats>
      </div>
    </div>
  </ng-template>

  <!-- TODO: Posture Deviation Summary -->
  <!-- <p style="page-break-after: always;">&nbsp;</p> -->

  <div class="section-wrapper pagebreak">
    <div class="section">
      <h1>Security Controls (Baselines)</h1>
      <div>
        <mat-icon class="safe icon" svgIcon="add_circle_outline"></mat-icon> Created
        <mat-icon class="red icon" svgIcon="error"></mat-icon> Deviation
        <mat-icon class="safe icon" svgIcon="construction"></mat-icon> Remediated
      </div>
      <div>
        <h2>Tenant Baseline(s)</h2>
      </div>
      <lib-tenant-security-control
        [categories]="tenant_catagories"
        [tenantBaselineDeviationsByCategory]="tenantBaselineDeviations$ | async"
      >
      </lib-tenant-security-control>
      <div>
        <h2>Group Baseline(s)</h2>
      </div>
      <lib-group-security-control
        [groupBaselineDeviations]="groupBaselineDeviations$ | async"
      >
      </lib-group-security-control>
    </div>
  </div>
</div>
